/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  function initEastWestProductGallery() {
    document.querySelectorAll('[data-section-type="product-template"]').forEach(function (section) {
      if (section.dataset.eastWestGalleryReady === 'true') return;

      var slider = section.querySelector('[data-product-single-media-slider]');
      var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-thumbnail-id]'));
      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-product-single-media-wrapper]'));

      if (!slider || !thumbs.length || !slides.length) return;

      function selectThumbnail(mediaId) {
        thumbs.forEach(function (thumb) {
          var selected = thumb.getAttribute('data-thumbnail-id') === mediaId;
          thumb.classList.toggle('is-nav-selected', selected);
          thumb.setAttribute('aria-current', selected ? 'true' : 'false');
        });
      }

      function selectMedia(mediaId) {
        var slideIndex = slides.findIndex(function (slide) {
          return slide.getAttribute('data-media-id') === mediaId;
        });

        if (slideIndex < 0) return;

        var dots = slider.querySelectorAll('.flickity-page-dots .dot');
        if (dots.length === slides.length && dots[slideIndex]) {
          dots[slideIndex].click();
        } else {
          slides.forEach(function (slide, index) {
            var selected = index === slideIndex;
            slide.classList.toggle('media--hidden', !selected);
            slide.classList.toggle('is-selected', selected);
          });
        }

        selectThumbnail(mediaId);
      }

      thumbs.forEach(function (thumb) {
        var mediaId = thumb.getAttribute('data-thumbnail-id');
        var link = thumb.querySelector('.product-single__thumbnail-link');

        if (!link) return;

        link.addEventListener('click', function (event) {
          event.preventDefault();
          selectMedia(mediaId);
        });
      });

      var selectedSlide = section.querySelector('[data-product-single-media-wrapper].is-selected') || slides[0];
      if (selectedSlide) selectThumbnail(selectedSlide.getAttribute('data-media-id'));

      var pageDots = slider.querySelector('.flickity-page-dots');
      if (pageDots) {
        new MutationObserver(function () {
          var activeDot = pageDots.querySelector('.dot.is-selected');
          var activeIndex = Array.prototype.indexOf.call(pageDots.querySelectorAll('.dot'), activeDot);
          if (activeIndex > -1 && slides[activeIndex]) {
            selectThumbnail(slides[activeIndex].getAttribute('data-media-id'));
          }
        }).observe(pageDots, { attributes: true, subtree: true, attributeFilter: ['class'] });
      }

      section.dataset.eastWestGalleryReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEastWestProductGallery);
  } else {
    initEastWestProductGallery();
  }

  document.addEventListener('shopify:section:load', initEastWestProductGallery);
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
